import {
  Button,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@material-ui/core";
import { TableCell } from "@mui/material";
import SearchBar from "material-ui-search-bar";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import http from "../services/httpService";
import {
  getDateTime,
  searchFilter,
  investorindividualRequestPath,
  investmentPath,
} from "../utils/varialbles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { IconFlagCA, IconFlagIN } from "material-ui-flags";
import toast from "react-hot-toast";

const getFlag = (country) => {
  if (country === "India") {
    return React.createElement(IconFlagIN);
  }
  if (country === "Canada") {
    return React.createElement(IconFlagCA);
  }
  if (country === "USA") {
    return React.createElement(IconFlagCA);
  }
};
function DeleteRequestTab({ props, id }) {
  const location = useLocation();
  const history = useHistory();
  const myparam = location.state;

  const [rows, setRows] = useState([]);
  const [orignalRows, setOriginalRows] = useState([]);
  const [searched, setSearched] = React.useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [columns, setColumns] = useState([
    {
      headerName: "User ID",
      type: "id",
    },
    {
      headerName: "Creation Date",
      id: "Creation_Date",
      type: "date",
    },
    {
      headerName: "Invested Amount",
      id: "Investment_Amount",
      type: "investamount",
    },
    {
      headerName: "Request Type",
      id: "Request_Type",
    },
    {
      headerName: "Date and Time of Deletion",
      id: "deleteddt",
      type: "date",
    },
    {
      headerName: "Deleted By",
      id: "deleted_by",
    },
    {
      headerName: "Note",
      id: "comment",
    },
  ]);

  const cancelSearch = (searchVal) => {
    setSearched(searchVal);
    let abc = "";
    getData(abc);
  };
  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];
    // (searchedVal)
    setPage(0);
    // setSearched(searchedVal, rowsTemp);
    setRows(searchFilter(searchedVal, rowsTemp));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const getPaginationURL = (url, newQuery) => {
    const query = newQuery ? newQuery : searched;
    if (query) {
      return `${url}?page=${
        page + 1
      }&rowsPerPage=${rowsPerPage}&search=${query}`;
    } else {
      return `${url}?page=${page + 1}&rowsPerPage=${rowsPerPage}`;
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = (newQuery) => {
    toast("please Wait");
    const baseURL =
      "/invrequest/" + location.state.customer_id + "?delete=true";
    // http
    //   .get(getPaginationURL(baseURL, newQuery))
    http
      .get("/invrequest/" + location.state.customer_id + "?delete=true")
      .then((res) => {
        toast.dismiss();
        if (res.data.statusCode === 0) {
          setRows(res.data.Investment_Request);
          setOriginalRows(res.data.Investment_Request);
        } else {
          setRows([]);
          setOriginalRows([]);
        }
        // (res.data.Investment_Request);
      })
      .catch((err) => {});
  };

  const gotoInvestTabs = () => {
    history.push({
      pathname: investorindividualRequestPath,
      state: {
        tab: "Investments",
        page: myparam.page,
        customer_id: location.state.customer_id,
      },
      userid: location.id,
    });
  };
  return (
    <div>
      <div>
        <Button
          variant="outlined"
          color="default"
          startIcon={<ArrowBackIosIcon />}
          onClick={gotoInvestTabs}
        >
          Back
        </Button>
      </div>

      <Typography variant="h4" style={{ margin: "5px 0 5px 0px" }}>
        DELETED REQUESTS
      </Typography>

      <div style={{ margin: "15px 0", width: 300 }}>
        <SearchBar
          value={searched}
          onChange={(searchVal) => requestSearch(searchVal)}
          onCancelSearch={() => cancelSearch()}
        />
      </div>

      <div style={{ margin: "20px 0 0px 0" }}>
        <TablePagination
          rowsPerPageOptions={[5, 10, 15, 25, 50, 100, 500, 1500]}
          component="div"
          // count={totalRowCount}
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((item) => {
                return <TableCell>{item.headerName}</TableCell>;
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length !== 0 ? (
              <>
                {rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    return (
                      <TableRow>
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell style={{ padding: 7 }}>
                              {column.type === "id"
                                ? location.id
                                : column.type === "date"
                                ? getDateTime(value)
                                : column.type === "investamount"
                                ? row.Country.map((item) => {
                                    return (
                                      <>
                                        <span style={{ marginRight: 10 }}>
                                          {getFlag(item.locname)}
                                        </span>
                                        <span>
                                          {item.currency + " " + value}
                                        </span>
                                      </>
                                    );
                                  })
                                : value
                                ? value
                                : "N/A"}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </>
            ) : (
              <TableCell
                colspan="7"
                style={{ "text-align": "center", margin: "10px 0px" }}
              >
                Records Not Available
              </TableCell>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default DeleteRequestTab;
